var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container py-5"
  }, [_c('div', {
    staticClass: "row justify-content-center text-center"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header registrar-title"
  }, [_vm._v("Registrarse")]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "txt_nombre"
    }
  }, [_vm._v("Nombre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.nombre,
      expression: "user.nombre"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "txt_nombre",
      "type": "text",
      "placeholder": "John Doe"
    },
    domProps: {
      "value": _vm.user.nombre
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "nombre", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "txt_email"
    }
  }, [_vm._v("Correo Electrónico")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email,
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "txt_email",
      "type": "text",
      "placeholder": "nombre@dominio.com"
    },
    domProps: {
      "value": _vm.user.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "email", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "txt_password"
    }
  }, [_vm._v("Contraseña")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.password,
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "txt_password",
      "type": "password",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.user.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "password", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "txt_password"
    }
  }, [_vm._v("Region")]), _c('v-select', {
    attrs: {
      "options": _vm.optionsRegion,
      "loading": _vm.loadingRegion
    },
    on: {
      "input": function input($event) {
        return _vm.handleClickSelectRegion($event);
      }
    },
    model: {
      value: _vm.user.region,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "region", $$v);
      },
      expression: "user.region"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "txt_password"
    }
  }, [_vm._v("Comuna")]), _c('v-select', {
    attrs: {
      "options": _vm.optionsComuna,
      "disabled": _vm.disabledComuna
    },
    model: {
      value: _vm.user.comuna,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "comuna", $$v);
      },
      expression: "user.comuna"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "txt_password"
    }
  }, [_vm._v("Dirección")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.direccion,
      expression: "user.direccion"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "txt_password",
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.user.direccion
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "direccion", $event.target.value);
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary btn-funko-primary w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.registrarUsuario
    }
  }, [_vm.loading ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('span', [_vm._v("Registrarse")])], 1)]), _c('div', {
    staticClass: "card-footer text-muted"
  }, [_c('p', {
    staticClass: "font-italic"
  }, [_vm._v(" ¿Ya tienes cuenta?, inicia sesion "), _c('span', {
    staticClass: "span-here",
    on: {
      "click": _vm.redirectToLogin
    }
  }, [_vm._v("aquí")])])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }